<template>
	<BaseLayout :footer-full="true" :include-padding="false" :transparent-header="true">
		<PremiumLandingHero />
		<PremiumLandingBenefits />
		<FeaturedStats background-color="gold-50" :stats="stats" wrapper-css="justify-content-center gap-600-md">
			<template #disclaimer>
				<p class="body-xs text-color-content-secondary text-align-center mt-250"
					><BaseButton classes="text-link text-color-content-secondary" @click="openModal">
						Learn more
					</BaseButton>
					about the assumptions of this section.</p
				>
			</template>
		</FeaturedStats>
		<PremiumLandingFeaturedOfferings />
		<AddToYourPortfolioSection
			title="Take your portfolio to the next level"
			component-id="premium-landing"
			:lead-capture-form-config="leadCaptureFormConfig"
			background-color="gold-50"
		/>
		<template #footer>
			<FooterFull>
				<template #additionalDisclaimer>
					<p
						>*Fundrise reserves the right to change or terminate this offer at any time for any reason at
						its sole discretion.</p
					>
					<br />
				</template>
			</FooterFull>
		</template>
	</BaseLayout>
</template>

<script setup lang="ts">
import AddToYourPortfolioSection from '@components/marketing-site/add-to-your-portfolio-section.vue';
import DisclaimerSimple from '@components/disclaimer/disclaimer-simple.vue';
import { FeaturedStat } from 'types/marketing-site';
import FeaturedStats from '@components/marketing-site/featured-stats.vue';
import FooterFull from '@components/footer/footer-full.vue';
import { LeadCaptureFormConfig } from 'types/layout/lead';
import PremiumLandingBenefits from '@components/marketing-site/premium-landing-page/premium-landing-benefits.vue';
import PremiumLandingFeaturedOfferings from '@components/marketing-site/premium-landing-page/premium-landing-featured-offerings.vue';
import PremiumLandingHero from '@components/marketing-site/premium-landing-page/premium-landing-hero.vue';
import { useAppStore } from '@stores/app';
import { useHead } from '@unhead/vue';

const appStore = useAppStore();

const stats: Array<FeaturedStat> = [
	{
		stat: '$3B+',
		description: 'Assets under <br class="display-none-smo display-none-mdo"/>management'
	},
	{
		stat: '$420M+',
		description: 'Cumulative net <br class="display-none-smo display-none-mdo"/>distributions'
	}
];

const leadCaptureFormConfig: LeadCaptureFormConfig = {
	signupFlowType: 'STANDARD',
	feeWaiver: 'PREMIUM_AUM_THRESHOLD_CROSSED',
	thirdPartyAuthTheme: 'PRIMARY',
	thirdPartyAuthDisclaimerClass: 'text-color-content-tertiary text-align-center'
};

function openModal(): void {
	appStore.updateCurrentModal({
		modal: DisclaimerSimple,
		props: {
			content: [
				'Distributions as of 2/10/2025. Other figures as of 12/31/2024.',
				'“Cumulative net distributions” is the total value of distributions earned by clients of Fundrise advisors, net of fees. Note that, as distributions are typically disbursed following the end of each quarter, a portion of the distributions shown at any time may have been earned but not yet disbursed.'
			],
			centeredContent: false
		}
	});
}

async function setup(): Promise<void> {
	useHead({
		title: 'Fundrise benefits at $100,000'
	});
}

setup();
</script>
